import script from "./OrderDetailBase.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrderDetailBase.vue?vue&type=script&lang=ts&setup=true"

import "./OrderDetailBase.vue?vue&type=style&index=0&id=6c18961a&lang=scss&scoped=true"
import "./OrderDetailBase.vue?vue&type=style&index=1&id=6c18961a&lang=scss"

import exportComponent from "/Users/breeze/data/code/src/gitlab.goiot.net/chargingc/cms/web2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c18961a"]])

export default __exports__